import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    RiDashboardLine,
    RiGridLine,
    RiPaletteLine,
    RiRulerLine,
    RiSettings4Line,
    RiShoppingBagLine,
    RiMenuLine,
    RiCloseLine
} from 'react-icons/ri';
import Button from '@/components/common/Button/Button';
import routes from '@/routes/routes';

import './AdminDashboard.css'

const AdminDashboard: React.FC = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const adminSections = [
        {
            title: 'Categorías',
            description: 'Gestionar las categorías de productos',
            icon: RiGridLine,
            path: routes.adminCategories,
            color: 'admin-card-blue'
        },
        {
            title: 'Materiales',
            description: 'Administrar los materiales disponibles',
            icon: RiPaletteLine,
            path: routes.adminMaterials,
            color: 'admin-card-green'
        },
        {
            title: 'Colores',
            description: 'Gestionar los colores disponibles',
            icon: RiPaletteLine,
            path: routes.adminColors,
            color: 'admin-card-purple'
        },
        {
            title: 'Tamaños',
            description: 'Administrar los tamaños disponibles',
            icon: RiRulerLine,
            path: routes.adminSizes,
            color: 'admin-card-orange'
        },
        {
            title: 'Personalizaciones',
            description: 'Gestionar opciones de personalización',
            icon: RiSettings4Line,
            path: routes.adminCustomizations,
            color: 'admin-card-red'
        },
        {
            title: 'Productos',
            description: 'Administrar el catálogo de productos',
            icon: RiShoppingBagLine,
            path: routes.adminProducts,
            color: 'admin-card-teal'
        }
    ];

    return (
        <div className="admin-dashboard">
            {/* Mobile Menu Button */}
            <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="admin-mobile-menu-btn"
            >
                {sidebarOpen ? <RiCloseLine /> : <RiMenuLine />}
            </button>

            {/* Sidebar */}
            <div className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
                <div className="admin-sidebar-header">
                    <h2 className="admin-sidebar-title">Panel de Administración</h2>
                </div>
                <nav className="admin-sidebar-nav">
                    <Link to="/admin" className="admin-sidebar-link active">
                        <RiDashboardLine className="admin-sidebar-icon" />
                        <span>Dashboard</span>
                    </Link>
                    {adminSections.map((section, index) => {
                        const Icon = section.icon;
                        return (
                            <Link
                                key={index}
                                to={section.path}
                                className="admin-sidebar-link"
                                onClick={() => setSidebarOpen(false)}
                            >
                                <Icon className="admin-sidebar-icon" />
                                <span>{section.title}</span>
                            </Link>
                        );
                    })}
                </nav>
            </div>

            {/* Main Content */}
            <div className="admin-main">
                <div className="admin-header">
                    <h1 className="admin-title">Panel de Administración Plastitex</h1>
                    <p className="admin-subtitle">
                        Gestiona tu catálogo de productos personalizables
                    </p>
                </div>

                <div className="admin-stats">
                    <div className="admin-stat-card">
                        <div className="admin-stat-number">24</div>
                        <div className="admin-stat-label">Categorías Activas</div>
                    </div>
                    <div className="admin-stat-card">
                        <div className="admin-stat-number">156</div>
                        <div className="admin-stat-label">Productos</div>
                    </div>
                    <div className="admin-stat-card">
                        <div className="admin-stat-number">1,247</div>
                        <div className="admin-stat-label">Pedidos Este Mes</div>
                    </div>
                    <div className="admin-stat-card">
                        <div className="admin-stat-number">$45,678</div>
                        <div className="admin-stat-label">Ingresos</div>
                    </div>
                </div>

                <div className="admin-grid">
                    {adminSections.map((section, index) => {
                        const Icon = section.icon;
                        return (
                            <Link
                                key={index}
                                to={section.path}
                                className={`admin-card ${section.color}`}
                            >
                                <div className="admin-card-icon">
                                    <Icon />
                                </div>
                                <div className="admin-card-content">
                                    <h3 className="admin-card-title">{section.title}</h3>
                                    <p className="admin-card-description">{section.description}</p>
                                </div>
                                <div className="admin-card-arrow">
                                    →
                                </div>
                            </Link>
                        );
                    })}
                </div>

                {/* Quick Actions */}
                <div className="admin-quick-actions">
                    <h2 className="admin-section-title">Acciones Rápidas</h2>
                    <div className="admin-actions-grid">
                        <Button variant="primary" className="admin-action-btn">
                            Nuevo Producto
                        </Button>
                        <Button variant="secondary" className="admin-action-btn">
                            Ver Pedidos
                        </Button>
                        <Button variant="secondary" className="admin-action-btn">
                            Reportes
                        </Button>
                        <Button variant="secondary" className="admin-action-btn">
                            Configuración
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
